export const filterOptions = [
  { name: "TSS", short: "TSS", value: 1, id: "assignedToName" },
  { name: "Ticket", short: "TCT", value: 2, id: "odooTicketNumber" },
  { name: "Status", short: "STT", value: 3, id: "status" },
  { name: "Customer ID", short: "CID", value: 4, id: "customerId" },
  { name: "Customer Name", short: "CN", value: 5, id: "customerName" },
  { name: "Customer Phone", short: "CPH", value: 6, id: "customerPhone" },
];
